import { Component, OnInit, Input } from '@angular/core';
import { ItemDetail } from 'src/app/models/item-detail.model';

@Component({
  selector: 'app-call-tag',
  templateUrl: './call-tag.component.html',
  styleUrls: [
    './call-tag.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallTagComponent implements OnInit {
  @Input() items: ItemDetail[];

  constructor() { }

  ngOnInit(): void {
  }

}
